/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Report_ResultsInputs */



/**
* | output |
* | --- |
* | "Report results to VEKN" |
*
* @param {Vekn_Report_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_report_results = /** @type {((inputs?: Vekn_Report_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Report_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer les résultats à VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar resultados a VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar resultados para a VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia i risultati a VEKN")
	return /** @type {LocalizedString} */ ("Report results to VEKN")
});